import { useEffect, useState } from "react";

let cache = null;

const DEFAULTS = {
  operator_name: "mindregen.ro",
  operator_email: "contact@mindregen.ro",
  contact_email: "contact@mindregen.ro",
  data_retention_period:
    "24 luni de la ultima interacțiune sau până la retragerea consimțământului, oricare survine prima",
};

export function useSiteConfig() {
  const [config, setConfig] = useState(cache);

  useEffect(() => {
    if (cache) return;
    let alive = true;
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/config`)
      .then((r) => r.json())
      .then((d) => {
        cache = d;
        if (alive) setConfig(d);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  return config || DEFAULTS;
}
